import gql from "graphql-tag";
export const defaultCurrency = {
  icon: "UnitedStates",
  id: "USD",
  multiplier: 1,
  name: "USD",
  symbol: "$",
  zeroDecimal: false
};
export const currencyQuery = gql`
  query currencyQuery {
    currencies {
      id
      icon
      multiplier
      name
      symbol
      zeroDecimal
    }
  }
`;
export function useCurrencies(props) {
  var _queryResults$data;

  const useQuery = props.useQuery; // @ts-ignore - graphql-proxy fails ts without this even though it does not reference this at all 😭

  const queryResults = useQuery(currencyQuery);
  return {
    currencies: (queryResults === null || queryResults === void 0 ? void 0 : (_queryResults$data = queryResults.data) === null || _queryResults$data === void 0 ? void 0 : _queryResults$data.currencies) || [],
    error: queryResults.error ? "There was an issue loading currencies. Please try again" : null,
    isLoading: queryResults.loading,
    onSelectCurrency: currency => queryResults.client.writeData({
      data: {
        selectedCurrency: currency
      }
    })
  };
}
//# sourceMappingURL=useCurrencies.js.map